
import Careers from "../company/Careers";

export { Page }

function Page() {
  return <Careers />;
}
